/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Value_EstimateInputs */

const cs_field_value_estimate = /** @type {(inputs: Field_Value_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhad hodnoty`)
};

const en_field_value_estimate = /** @type {(inputs: Field_Value_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value estimate`)
};

/**
* | output |
* | --- |
* | "Value estimate" |
*
* @param {Field_Value_EstimateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_value_estimate = /** @type {((inputs?: Field_Value_EstimateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Value_EstimateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_value_estimate(inputs)
	return cs_field_value_estimate(inputs)
});